import { RootState } from '@utils/types';
import { FaUserCircle } from 'react-icons/fa';
import { useSelector } from 'react-redux';

const UserDetail = () => {
  const { fullName, segmentName } = useSelector(
    (state: RootState) => state.user,
  );

  return (
    <>
      <FaUserCircle className="ml-2 h-10 w-10 lg:h-9 lg:w-9" />
      <div className="ml-2 flex flex-col font-semibold">
        <span className="text-base lg:text-sm">{fullName}</span>
        <span className="text-xs text-gray-500">{segmentName}</span>
      </div>
    </>
  );
};

export default UserDetail;
